// Legacy Hindi / Marathi font -> Unicode Devanagari conversion.
//
// Do not treat Kruti Dev and DevLys as identical encodings.
// Each supported font family/version gets its own converter.
import {
  convertKrutiDev010ToUnicode,
} from './legacy-fonts/krutiDev010';

import {
  convertKrutiDev055ToUnicode,
} from './legacy-fonts/krutiDev055';

import {
  convertKrutiDev714ToUnicode,
} from './legacy-fonts/krutiDev714';


export const LEGACY_FONTS = [
  'Not Applicable',
  'Kruti Dev 010/011',
  'Kruti Dev 055 (Marathi)',
  'Kruti Dev 714',
  // 'DevLys 010',
];

const normalizeLegacyInput = (text = '') =>
  text
    .replace(/\u00A0/g, ' ')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n');

const safeConvert = (text, converter, converterName) => {
  if (!text) return '';

  const normalized = normalizeLegacyInput(text);

  try {
    return converter(normalized).normalize('NFC');
  } catch (error) {
    console.error(`${converterName} conversion failed:`, error);

    // Preserve original input rather than corrupting it.
    return normalized;
  }
};

const convertKrutiDev010 = (text = '') =>
  safeConvert(
    text,
    convertKrutiDev010ToUnicode,
    'Kruti Dev 010/011'
  );

const convertKrutiDev055 = (text = '') =>
  safeConvert(
    text,
    convertKrutiDev055ToUnicode,
    'Kruti Dev 055 (Marathi)'
  );

const convertKrutiDev714 = (text = '') =>
  safeConvert(
    text,
    convertKrutiDev714ToUnicode,
    'Kruti Dev 714'
  );

// const convertDevLys010 = (text = '') =>
//   safeConvert(
//     text,
//     convertDevLys010ToUnicode,
//     'DevLys 010'
//   );

const CONVERTERS = {
  'Kruti Dev 010/011': convertKrutiDev010,
  'Kruti Dev 055 (Marathi)': convertKrutiDev055,
  'Kruti Dev 714': convertKrutiDev714,
  // 'DevLys 010': convertDevLys010,
};

export const convertLegacyToUnicode = (text, font) => {
  const input = text || '';
  const converter = CONVERTERS[font];

  return converter ? converter(input) : input;
};

export const isLegacyFontSelected = (font) =>
  Boolean(CONVERTERS[font]);